declare namespace $ {

	type $mol_string__hint_bog_dobro_app_vaka_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_dobro_app_vaka_2 = $mol_type_enforce<
		ReturnType< $bog_dobro_app_vaka['query'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_select__options_bog_dobro_app_vaka_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__value_bog_dobro_app_vaka_4 = $mol_type_enforce<
		ReturnType< $bog_dobro_app_vaka['area_name'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_button_minor__hint_bog_dobro_app_vaka_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_dobro_app_vaka_6 = $mol_type_enforce<
		ReturnType< $bog_dobro_app_vaka['search'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_dobro_app_vaka_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_bar__sub_bog_dobro_app_vaka_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_bar['sub'] >
	>
	type $mol_status__status_bog_dobro_app_vaka_9 = $mol_type_enforce<
		ReturnType< $bog_dobro_app_vaka['loading_status'] >
		,
		ReturnType< $mol_status['status'] >
	>
	type $mol_text__text_bog_dobro_app_vaka_10 = $mol_type_enforce<
		ReturnType< $bog_dobro_app_vaka['stats_message'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_bar__sub_bog_dobro_app_vaka_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_bar['sub'] >
	>
	type $mol_list__rows_bog_dobro_app_vaka_12 = $mol_type_enforce<
		ReturnType< $bog_dobro_app_vaka['vacancy_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_text__text_bog_dobro_app_vaka_13 = $mol_type_enforce<
		ReturnType< $bog_dobro_app_vaka['empty_message'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_bog_dobro_app_vaka_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__uri_bog_dobro_app_vaka_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__title_bog_dobro_app_vaka_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	export class $bog_dobro_app_vaka extends $mol_page {
		query( next?: string ): string
		Query( ): $mol_string
		area_name( next?: string ): string
		Area( ): $mol_select
		Search_icon( ): $mol_icon_magnify
		Search( ): $mol_button_minor
		Tools( ): $mol_bar
		loading_status( ): any
		Status( ): $mol_status
		stats_message( ): string
		Stats_text( ): $mol_text
		Stats_bar( ): $mol_bar
		vacancy_rows( ): readonly(any)[]
		Results( ): $mol_list
		Empty_icon( ): $mol_icon_information_outline
		empty_message( ): string
		Empty_message( ): $mol_text
		Empty( ): $mol_view
		Credits( ): $mol_link
		search( next?: any ): any
		title( ): string
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
		foot( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=vaka.view.tree.d.ts.map